export default __webpack_public_path__ + "static/media/kiawe.286475af.png";